"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const client_1 = require("./client");
class RestClient extends client_1.RoamClient {
    constructor(props) {
        super();
        this.apiKey = props.apiKey || process.env.ROAM_CLIENT_API_KEY || "";
        this.apiToken = props.apiToken || process.env.ROAM_CLIENT_API_TOKEN || "";
        this.graphName = props.graphName;
        this.contentType = props.contentType || "application/json";
        if (!this.apiKey) {
            throw new Error("Rest Client is missing an API Key");
        }
        if (!this.apiToken) {
            throw new Error("Rest Client is missing an API Token");
        }
    }
    post(body) {
        return axios_1.default
            .post("https://4c67k7zc26.execute-api.us-west-2.amazonaws.com/v1/alphaAPI", Object.assign(Object.assign({}, body), { "graph-name": this.graphName }), {
            headers: {
                "x-api-key": this.apiKey,
                "x-api-token": this.apiToken,
                "Content-Type": this.contentType,
            },
        })
            .then((r) => r.data.success);
    }
}
exports.default = RestClient;
